/* Tuning constants, the starter word list, and the game table.
 * Pure data: imports nothing, so anything may import it. */

export const DAY = 864e5;
export const KEY = "vokabelspiel.v3";


/* ================= the learning model =================
   Two things move when you answer, and neither treats a guess
   like real knowledge.

   lp: learning progress, 0 to 2. Below 2 a word is in the learning
         phase: it comes back in minutes, never days. It only graduates
         to real spaced repetition at 2.0.
   sk: one credit score per skill (rec / gen / pro / app). A skill is
         met at 2.5, and that's what moves a word up a stage.

   Both are fed by the same weighted credit, so what an answer is worth
   depends on how much of it could have been a guess.
====================================================== */
export const MET = 2.5;          // credit needed in a skill to clear its stage
export const GRADUATE = 2.0;     // learning progress needed to leave the learning phase
export const LEARN = [60e3, 9 * 60e3, 25 * 60e3];   // learning steps: 1, 9, 25 minutes

export const STAGES=[
 {n:"Neu",         e:"never seen"},
 {n:"Erkennen",    e:"recognise it"},
 {n:"Formen",      e:"der, die, das"},
 {n:"Produzieren", e:"recall it yourself"},
 {n:"Anwenden",    e:"use it in context"},
 {n:"Sicher",      e:"holding long-term"}
];

export const GAMES={
 paare:   {t:"Paare",           d:"match German to English",         s:0, sk:"rec", w:0.6, n:6,  odds:"self-checking"},
 wahr:    {t:"Wahr oder falsch",d:"60-second recognition sprint",    s:1, sk:"rec", w:0.5, n:24, odds:"1 in 2", sprint:60},
 schnell: {t:"Schnellwahl",     d:"pick the meaning, 7s each",       s:1, sk:"rec", w:0.8, n:10, odds:"1 in 4"},
 blasen:  {t:"Wortblasen",      d:"tap the right word among the bubbles",s:1,sk:"rec",w:0.8, n:40, odds:"scanning, 4-7 bubbles", arcade:"blasen"},
 plural:  {t:"Mehrzahl",       d:"type the plural form",            s:2, sk:"gen", w:1.2, n:8,  odds:"nothing given"},
 artikel: {t:"Artikel",         d:"der, die or das",                 s:2, sk:"gen", w:0.7, n:10, odds:"1 in 3"},
 salat:   {t:"Buchstabensalat", d:"build the word from its letters", s:3, sk:"pro", w:1.1, n:8,  odds:"letters given"},
 tippen:  {t:"Tippen",          d:"type it with nothing to go on",   s:3, sk:"pro", w:1.4, n:8,  odds:"nothing given"},
 luecke:  {t:"Lückentext",      d:"fill the gap in a sentence",      s:4, sk:"app", w:0.8, n:8,  odds:"1 in 4"},
 hoeren:  {t:"Hören",           d:"listen, then pick the meaning",   s:4, sk:"app", w:0.8, n:8,  odds:"1 in 4"}
};

export const SEED = [
["das","Haus","Häuser","house","Das Haus ist sehr groß und alt.","n"],
["die","Katze","-n","cat","Meine Katze schläft gern auf dem Sofa.","n"],
["der","Hund","-e","dog","Der Hund spielt gern im Garten.","n"],
["das","Wasser","","water","Ich trinke jeden Morgen ein Glas Wasser.","n"],
["der","Tisch","-e","table","Der Tisch steht mitten im Zimmer.","n"],
["die","Schule","-n","school","Die Schule beginnt um acht Uhr morgens.","n"],
["das","Buch","Bücher","book","Dieses Buch ist wirklich sehr interessant.","n"],
["der","Freund","-e","friend","Mein Freund wohnt in einer anderen Stadt.","n"],
["die","Familie","-n","family","Meine Familie kommt am Wochenende zu Besuch.","n"],
["das","Auto","-s","car","Unser Auto ist leider schon sehr alt.","n"],
["der","Tag","-e","day","Heute ist ein wirklich schöner Tag.","n"],
["die","Woche","-n","week","Nächste Woche fahre ich in den Urlaub.","n"],
[null,"gehen",null,"to go","Wir gehen heute Abend ins Kino.","v"],
[null,"essen",null,"to eat","Die Kinder essen gerade ihr Mittagessen.","v"],
[null,"trinken",null,"to drink","Er trinkt jeden Tag viel Wasser.","v"],
[null,"wohnen",null,"to live, to reside","Sie wohnt seit zwei Jahren hier.","v"],
[null,"lernen",null,"to learn","Ich lerne jeden Abend etwas Deutsch.","v"],
[null,"schön",null,"beautiful, nice","Das Wetter heute ist wirklich schön.","a"],
[null,"klein",null,"small","Ihre Wohnung ist ziemlich klein aber gemütlich.","a"],
[null,"groß",null,"big, tall","Er ist für sein Alter schon sehr groß.","a"]
];
